function forwardError(fn) {
  return function(data) {
    if (typeof data === 'string') return data
    return fn(data)
  }
}

module.exports = forwardError
